// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 483 ? "owl-carousel" : chunkId) + "." + {"190":"f86b8d05","483":"66d70c81"}[chunkId] + ".chunk.js";
};